<template>
  <div class="webdatalist">
    <f7-list media-list accordion class="searchbar-found" id="bank-list">
      <f7-list-item
        accordion-item accordion-item-opened
        v-for="account in filteredBankAccounts"
        media="<i class='icon list-icon icon-credit_card'></i>"
        class="accordion-item-expanded boxRequest"
        :key="account.id"
        :title="account.name"
        :subtitle="formattedBankData(account.iban, account.zoneCode)">

        <f7-accordion-content class="greyfont">
          <div v-if="account.balances !== undefined && account.balances.length > 0" class="data-table card statementTable">
            <table class="showLargeScreenOnly">
              <thead>
                <tr>
                  <th width='10%'>{{ $t('common.oper_date') }}</th>
                  <th width='20%'>{{ $t('common.oper_id') }}</th>
                  <th width='20%'>{{ $t('common.to_label') + '/' + $t('common.from') }}</th>
                  <th width='20%'>{{ $t('common.oper_label') }}</th>
                  <th width='15%'>{{ $t('common.amnt') }}</th>
                  <th width='10%'>{{ "Lettrage" }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="mainLineStatementTable">
                <tr v-for="balance in account.balances">
                  <td>{{balance.date}}</td>
                  <td>{{balance.endToEndId}}</td>
                  <td>{{balance.name}}</td>
                  <td>{{balance.remittanceInformation}}</td>
                  <td>
                    <span v-if="balance.indicator==='0'">
                      -
                    </span>
                    <span v-else>
                      +
                    </span> {{balance.amount.replace('.', ',')}} {{ getCurrency(account.zoneCode) }}
                  </td>
                  <td>{{formatLettrage(balance.lettrage)}}</td>
                </tr>
              </tbody>
            </table>
            <table class="showSmallScreenOnly statementSmallScreen">
              <tbody>
                <tr v-for="balance in account.balances">
                  <td>
                    <span class="smallScreenStatementDescription pull-left">{{ $t('common.oper_date') }} : </span>
                    <span class="pull-right">{{balance.date}}</span>
                    <br />
                    <span class="smallScreenStatementDescription pull-left">{{ $t('common.oper_id') }} : </span>
                    <span class="pull-right">{{balance.endToEndId}}</span>
                    <br />
                    <span class="smallScreenStatementDescription pull-left">{{ $t('common.to_label') + '/' + $t('common.from') }} : </span>
                    <span class="pull-right">{{balance.name}}</span>
                    <br />
                    <span class="smallScreenStatementDescription pull-left">{{ $t('common.oper_label') }} : </span>
                    <span class="pull-right">{{balance.remittanceInformation}}</span>
                    <br />
                    <span class="smallScreenStatementDescription pull-left">{{ $t('common.amnt') }} : </span>
                    <span class="mainLineStatementTable pull-right">
                      <span v-if="balance.indicator==='0'">-</span>
                      <span v-else>+</span>
                      {{balance.amount.replace('.', ',')}} {{ getCurrency(account.zoneCode) }}
                    </span>
                    <br />
                    <span class="smallScreenStatementDescription pull-left">{{ "Lettrage" }} : </span>
                    <span class="pull-right">{{formatLettrage(balance.lettrage)}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-center">
            <div class="emptyStatement"><i class="margin-icon"> {{$t('bank_accounts.no_statement_available')}} </i></div>
          </div>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>
</div>
</template>

<script>
import {extractForeignIban, formatLettrage} from '@/helpers/format'

export default {
  name: 'BankAccountList',
  props: ['bankAccounts', 'filterBy'],
  created () {
    this.bankAccountSelected = this.$engine.bankAccounts.getIbanStatment()
  },
  computed: {
    filteredBankAccounts () {
      let that = this
      let result = []
      if (this.filterBy) {
        for (var m in that.bankAccounts) {
          if (that.bankAccounts[m].name.toLowerCase().includes(this.filterBy.toLowerCase())) {
            result.push(that.bankAccounts[m])
          }
        }
        if (result.length !== 0) {
          that.Dom7('.page-on-center .searchbar-not-found').css('display', 'none')
          that.Dom7('.page-on-center #bank-list').css('display', 'block')
        }
        return result
      }

      /* TLV 08/01/2020
      * On sélectionne ensuite seulement les comptes liés à l'IBAN actuel, s'il n'y en a qu'un seul de sélectionné
      */
      if (this.bankAccountSelected !== '') {
        for (var p in that.bankAccounts) {
          if (that.bankAccounts[p].iban.toLowerCase() === this.bankAccountSelected.toLowerCase()) {
            result.push(that.bankAccounts[p])
          }
        }
        return result
      }
      return this.bankAccounts
    }
  },
  methods: {
    /** @author TLV 19/05/2020
    * @fn formattedBankData
    * @brief prépare les données bancaires (sort code, account number etc) à afficher sur les statements
    */
    formattedBankData (iban, zone) {
      zone = this.$i18n.t('zoneCodes.' + zone)
      let bankDataToString = ''
      let extractedDataFromIban = extractForeignIban(iban, zone)
      for (let accountData in extractedDataFromIban) {
        bankDataToString += this.$i18n.t(extractedDataFromIban[accountData].labelId) + ' : ' +
                            extractedDataFromIban[accountData].hiddenValue + ' '
      }
      return bankDataToString
    },
    getCurrency (zoneCode) {
      return this.$engine.bankAccounts.getCurrency(zoneCode)
    },
    formatLettrage: formatLettrage
  }
}
</script>
